import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { LanguageConsumer } from 'contexts/legacy/LanguageContext';
import { NumberContext } from 'contexts/legacy/NumberContext';
import { SystemConsumer } from 'contexts/legacy/SystemContext';
import React from 'react';
import { api, apiV2, dialogApi } from 'services/api';

class NumberProvider extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			numbers: {
				actives: [],
				inactives: [],
			},
			basicNumbers: {
				actives: [],
				inactives: [],
			},
			proNumbers: {
				actives: [],
				inactives: [],
			},
			campaigns: [],
			deals_categories: [],
			deals_stages: [],
			all_deals_stages: [],
			leads_statuses: [],
			user: null,
			creationBasicLimit: true,
			creationProLimit: true,
			is_new_plan: false,
			max_numbers_basic: 0,
			max_numbers_pro: 0,
			active_numbers_basic: 0,
			connected_numbers_pro: 0,
			qtd_of_numbers: 0,
			connected_channels: [],
			loadingConnectedChannels: true,
			placement: null,
			apis: [],
			lang: 'en',
			tutorials: [],
			loadingNumber: true,
			loadingDealsCategories: true,
			loadingDealsStages: true,
			loadingLeadsStatuses: true,
			loadingApis: true,
			loadingAddNumber: false,
			loadingTutorials: true,
			loadingSendMessage: false,
			loadingNumbersStatus: false,
			isWellcomeScreen: false,

			log_messages_data: [],
			log_messages_loading: false,

			b24_access_token: null,

			// Cache for number settings to avoid redundant API calls
			numberSettingsCache: new Map(),

			infos: {
				domain: '',
				auth: '',
			},
			proTrialAvailable: false,
			getProTrialAvailability: this.getProTrialAvailability.bind(this),
			getListOfDealsCategories: this.getListOfDealsCategories.bind(this),
			getListOfDealsStages: this.getListOfDealsStages.bind(this),
			getListOfLeadsStatuses: this.getListOfLeadsStatuses.bind(this),
			getListOfDealsStagesFiltered: this.getListOfDealsStagesFiltered.bind(this),
			getListOfNumbers: this.getListOfNumbers.bind(this),
			getListOfApi: this.getListOfApi.bind(this),
			getListCampaigns: this.getListCampaigns.bind(this),
			messagesOnQueue: this.messagesOnQueue.bind(this),
			clearQueue: this.clearQueue.bind(this),
			deleteNumber: this.deleteNumber.bind(this),
			addEditNumber: this.addEditNumber.bind(this),
			getConnectedChannels: this.getConnectedChannels.bind(this),
			sendMessage: this.sendMessage.bind(this),
			startContainer: this.startContainer.bind(this),
			startSession: this.startSession.bind(this),
			getQRCode: this.getQRCode.bind(this),
			getSdkConnectorToken: this.getSdkConnectorToken.bind(this),
			getSessionInfo: this.getSessionInfo.bind(this),
			deleteSession: this.deleteSession.bind(this),
			clearCampaignQueue: this.clearCampaignQueue.bind(this),
			saveNumberSettings: this.saveNumberSettings.bind(this),
			getNumberSettings: this.getNumberSettings.bind(this),
			loadTranscriptionSettingsForNumbers: this.loadTranscriptionSettingsForNumbers.bind(this),
			clearNumberSettingsCache: this.clearNumberSettingsCache.bind(this),
			deleteNumberSettings: this.deleteNumberSettings.bind(this),
			getNumbersStatus: this.getNumbersStatus.bind(this),
		};
	}

	async UNSAFE_componentWillMount() {
		window.BX24.init(async () => {
			const auth = window.BX24 ? window.BX24.getAuth() : { domain: 'solinka.bitrix24.com' };

			if (window.BX24) {
				this.setState({ b24_access_token: auth.access_token });
				await window.BX24.callMethod('user.current', {}, async (res) => {
					let user = res.data();
					user = user || {
						NAME: '',
						EMAIL: '',
						PERSONAL_PHONE: '',
					};

					this.setState({ user });
				});
			}
			const domain = auth.domain;
			const lang = window.BX24 ? window.BX24.getLang() : 'en';
			const placement = window.BX24 ? window.BX24.placement.info() : null;

			this.setState({ lang, placement });

			await this.loadClientInfos(domain)
				.then(() => {
					this.getListOfApi();
					this.getProTrialAvailability();
					if (!this.props.step) {
						this.getListOfNumbers();
						this.getListCampaigns();
						this.getConnectedChannels();
						if (window.mobileCheck()) {
							this.getListOfDealsCategories();
							this.getListOfDealsStages();
							this.getListOfLeadsStatuses();
						}
					}
				})
				.catch((e) => {
					console.log('NumberProvider::componentDidMount - loadClientInfos', {
						Exception: e,
					});
				});
		});
	}

	loadClientInfos(domain) {
		return new Promise(async (resolve, reject) => {
			this.setState({ loadingClient: true });
			const request = {
				action: 'getClient',
				domain,
			};

			await api.post('getClient', request).then(async (res) => {
				this.setState({ loadingClient: false });
				if (res.data.status) {
					this.setState({ infos: res.data.dados }, () => {
						resolve(res.data);
					});
				} else {
					reject(res.data);
				}
			});
		});
	}

	async getListOfNumbers() {
		this.setState({ loadingNumber: true });
		const request = {
			action: 'getPermittedNumbers',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			userBitrixId: this.state.user ? this.state.user.ID : null,
			isAdmin: window.BX24.isAdmin(),
		};

		await api
			.post('getPermittedNumbers', request)
			.then(async (res) => {
				this.setState({ loadingNumber: false });
				if (res.data.status) {
					// Load transcription settings for all numbers
					const allNumbers = [].concat(
						res.data.dados.list.basic.actives,
						res.data.dados.list.basic.inactives,
						res.data.dados.list.pro.actives,
						res.data.dados.list.pro.inactives,
					);

					allNumbers.forEach((numberInfo) => {
						if (numberInfo.number) {
							numberInfo.audio_transcription = 0;
						}
					});

					this.setState({ basicNumbers: res.data.dados.list.basic });
					this.setState({ proNumbers: res.data.dados.list.pro });

					const numbers = {
						actives: [].concat(res.data.dados.list.basic.actives, res.data.dados.list.pro.actives),

						inactives: [].concat(
							res.data.dados.list.basic.inactives,
							res.data.dados.list.pro.inactives,
						),
					};

					this.setState({ numbers });
					this.setState({ qtd_of_numbers: res.data.dados.qtd_of_numbers });

					this.getNumbersStatus(allNumbers);

					await this.loadTranscriptionSettingsForNumbers(allNumbers);

					this.setState({
						creationBasicLimit: res.data.dados.active_basic < res.data.dados.max_numbers_basic,
					});

					const totalProNumbers =
						res.data.dados.list.pro.actives.length + res.data.dados.list.pro.inactives.length;

					if (res.data.dados.is_trial) {
						this.setState({
							creationProLimit: totalProNumbers < res.data.dados.max_number_instances,
						});
						this.setState({
							proTrialAvailable: totalProNumbers < res.data.dados.max_number_instances,
						});
					} else {
						this.setState({
							creationProLimit: totalProNumbers < res.data.dados.max_numbers_pro,
						});
						this.setState({
							proTrialAvailable: totalProNumbers < res.data.dados.max_numbers_pro,
						});
					}

					if (res.data.dados.is_new_plan) {
						this.setState({
							is_new_plan: true,
							max_numbers_basic: res.data.dados.max_numbers_basic,
							max_numbers_pro: res.data.dados.max_numbers_pro,
							active_numbers_basic: res.data.dados.active_basic,
							connected_numbers_pro: res.data.dados.connected_pro,
						});
					} else {
						this.setState({
							is_new_plan: false,
							max_numbers_basic:
								res.data.dados.max_numbers_basic === 99 ? '∞' : res.data.dados.max_numbers_basic,
							max_numbers_pro: res.data.dados.max_numbers_pro,
							active_numbers_basic: res.data.dados.active_basic,
							connected_numbers_pro: res.data.dados.connected_pro,
						});
					}
				}
			})
			.catch((error) => {
				this.setState({ loadingNumber: false });
				console.warn('Falha ao carregar lista de números:', error);
			});
	}

	async getProTrialAvailability() {
		const request = {
			action: 'getProTrialAvailability',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
		};

		await api.post('getProTrialAvailability', request).then((res) => {
			if (res.data.status) {
				this.setState({ proTrialAvailable: res.data.dados.available });
			}
		});
	}

	async getListOfDealsCategories() {
		this.setState({ loadingDealsCategories: true });
		this.setState({ loadingNumber: true });
		const params = {
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			b24_access_token: this.state.b24_access_token,
		};

		await api.get('/deals/categories', { params }).then(async (res) => {
			this.setState({ loadingDealsCategories: false });
			this.setState({ loadingNumber: false });

			this.setState({ deals_categories: res.data });
		});
	}

	async getListOfDealsStages() {
		this.setState({ loadingDealsStages: true });
		this.setState({ loadingNumber: true });
		const params = {
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			b24_access_token: this.state.b24_access_token,
		};

		await api.get('/deals/stages', { params }).then(async (res) => {
			this.setState({ loadingDealsStages: false });
			this.setState({ loadingNumber: false });

			this.setState({ all_deals_stages: res.data });
		});
	}

	async getListOfLeadsStatuses() {
		this.setState({ loadingLeadsStatuses: true });
		this.setState({ loadingNumber: true });
		const params = {
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			b24_access_token: this.state.b24_access_token,
		};

		await api.get('/leads/statuses', { params }).then(async (res) => {
			this.setState({ loadingLeadsStatuses: false });
			this.setState({ loadingNumber: false });

			this.setState({ leads_statuses: res.data });
		});
	}

	getListOfDealsStagesFiltered(categoryId) {
		this.setState({ loadingDealsStages: true });
		if (this.state.all_deals_stages[categoryId] !== undefined) {
			const filtered = this.state.all_deals_stages[categoryId];
			this.setState({ deals_stages: filtered });
		}
		this.setState({ loadingDealsStages: false });
	}

	async getConnectedChannels() {
		this.setState({ loadingConnectedChannels: true });
		const request = {
			action: 'getConnectedChannels',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
		};

		await api.post('getConnectedChannels', request).then((res) => {
			this.setState({ loadingConnectedChannels: false });
			if (res.data.status) {
				this.setState({ connected_channels: res.data.dados });
			}
		});
	}

	async startContainer(number) {
		const request = {
			action: 'startContainer',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			api: number.api,
			token: number.token,
			client: { domain: this.state.infos.domain },
		};
		let result;
		await api
			.post('startContainer', request)
			.then((res) => {
				result = res.data;
			})
			.catch((e) => {
				console.log('NumberProvider::startContainer', { Exception: e });
			});
		return result;
	}

	async startSession(number) {
		const request = {
			action: 'startSession',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			api: number.api,
			token: number.token,
			client: { domain: this.state.infos.domain },
		};
		let result;
		await api
			.post('startSession', request)
			.then((res) => {
				result = res.data;
			})
			.catch((e) => {
				console.log('NumberProvider::startSession', { Exception: e });
			});
		return result;
	}

	async deleteSession(number) {
		const request = {
			action: 'deleteSession',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			api: number.api,
			token: number.token,
			client: { domain: this.state.infos.domain },
		};
		let result;
		await api
			.post('deleteSession', request)
			.then((res) => {
				result = res.data;
			})
			.catch((e) => {
				result = { status: false, error: e };
				console.log('NumberProvider::deleteSession', { Exception: e });
			});
		return result;
	}

	async getQRCode(number) {
		const request = {
			action: 'getQRCode',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			api: number.api,
			token: number.token,
			client: { domain: this.state.infos.domain },
		};
		let result;

		if (number.api !== 'zapi') {
			return;
		}

		await api
			.post('getQRCode', request)
			.then((res) => {
				result = res.data;
			})
			.catch((e) => {
				result = { status: false, error: e };
				console.log('NumberProvider::getQRCode', { Exception: e });
			});
		return result;
	}

	/**
	 * Busca, just-in-time, o token de sessão de curta duração do Connection SDK da Z-API
	 * (método alternativo ao QR Code, usado por `ZAPIConnector.open({ token })`).
	 *
	 * Segue o mesmo padrão de request de `getQRCode`/`getSessionInfo`, incluindo o mesmo guard
	 * de `api === 'zapi'` — o Connection SDK é específico da Z-API, e o backend
	 * (`AppController::sessionMethods`) despacha a `action` direto para o connector
	 * correspondente sem allowlist, então chamar isso para outra API tende a estourar erro
	 * fatal no connector dela em vez de um erro tratado.
	 */
	async getSdkConnectorToken(number) {
		if (number.api !== 'zapi') {
			return { status: false, error: 'unsupported_api' };
		}

		const request = {
			action: 'getSdkConnectorToken',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			api: number.api,
			token: number.token,
			client: { domain: this.state.infos.domain },
		};
		let result;

		await api
			.post('getSdkConnectorToken', request)
			.then((res) => {
				result = res.data;
			})
			.catch((e) => {
				result = { status: false, error: e };
				console.log('NumberProvider::getSdkConnectorToken', { Exception: e });
			});
		return result;
	}

	async getSessionInfo(number) {
		const request = {
			action: 'getSessionInfo',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			api: number.api,
			token: number.token,
			client: { domain: this.state.infos.domain },
		};
		let result;
		await api
			.post('getSessionInfo', request)
			.then((res) => {
				result = res.data;
			})
			.catch((e) => {
				console.log('NumberProvider::getSessionInfo', { Exception: e });
				result = { status: false, error: e };
			});
		return result;
	}

	async addEditNumber(number) {
		return new Promise(async (resolve, reject) => {
			this.setState({ loadingAddNumber: true });
			const request = {
				action: 'addEditNumber',
				domain: this.state.infos.domain,
				auth: this.state.infos.auth,
				...number,
			};

			await api.post('addEditNumber', request).then((res) => {
				this.setState({ loadingAddNumber: false });
				if (res.data.status === 'true' || res.data.status === 'true_inactive') {
					resolve(res.data);
				} else {
					const { msg } = res.data;
					if (
						msg === 'no_available_plans_yet' ||
						msg === 'no_available_plans_more' ||
						msg === 'no_available_plans'
					) {
						this.setState({ creationLimit: true });
					}
					reject(res.data);
				}
			});
		});
	}

	async saveNumberSettings(openaiToken, numberPhone, audioTranscription) {
		if (!numberPhone?.trim()) {
			throw new Error('Phone number is required');
		}

		try {
			// Build payload conditionally - only include openaiApiKey when token should be updated
			const payload = {
				transcribeAudios: audioTranscription !== undefined ? audioTranscription : false,
			};

			// Only include openaiApiKey in payload if token is provided (not null)
			if (openaiToken !== null) {
				payload.openaiApiKey = openaiToken || '';
			}
			const response = await apiV2.put('/number-settings', payload, {
				params: {
					domain: this.state.infos.domain,
					number: numberPhone,
				},
				headers: {
					'access-token': this.state.b24_access_token,
				},
			});

			// Clear cache for this number since settings have been updated
			this.state.numberSettingsCache.delete(numberPhone);

			return response.data;
		} catch (error) {
			const errorMessage =
				error.response?.data?.message || error.message || 'Failed to save OpenAI settings';
			throw new Error(`Failed to save OpenAI settings: ${errorMessage}`);
		}
	}

	async getNumberSettings(numberPhone) {
		if (!numberPhone?.trim()) {
			return { hasToken: false, maskedToken: null, audioTranscription: false };
		}

		// Check cache first
		if (this.state.numberSettingsCache.has(numberPhone)) {
			return this.state.numberSettingsCache.get(numberPhone);
		}

		const defaultSettings = { hasToken: false, maskedToken: null, audioTranscription: false };
		this.state.numberSettingsCache.set(numberPhone, defaultSettings);
		return defaultSettings;
	}

	async loadTranscriptionSettingsForNumbers(numbers) {
		if (!numbers || numbers.length === 0) return;

		try {
			// Filter out numbers that don't have a phone number or are already cached
			const numbersToFetch = numbers
				.filter(
					(numberInfo) =>
						numberInfo.number && !this.state.numberSettingsCache.has(numberInfo.number),
				)
				.map((numberInfo) => numberInfo.number);

			if (numbersToFetch.length === 0) {
				numbers.forEach((numberInfo) => {
					if (numberInfo.number) {
						const cachedSettings = this.state.numberSettingsCache.get(numberInfo.number);
						if (cachedSettings) {
							numberInfo.audio_transcription = cachedSettings.audioTranscription ? 1 : 0;
						} else {
							numberInfo.audio_transcription = 0;
						}
					}
				});
				return;
			}
			try {
				const response = await apiV2.get('/number-settings', {
					params: {
						domain: this.state.infos.domain,
						numbers: numbersToFetch.join(','),
					},
					headers: {
						'access-token': this.state.b24_access_token,
					},
				});

				const settingsMap = response.data;

				Object.keys(settingsMap).forEach((number) => {
					const settings = settingsMap[number];
					const cachedSettings = {
						hasToken: !!settings.hasApiKey,
						maskedToken: settings.openaiApiKey || null,
						audioTranscription: !!settings.transcribeAudios,
					};
					this.state.numberSettingsCache.set(number, cachedSettings);
				});
			} catch (error) {
				return;
			}

			// Now apply settings to all numbers (from cache or fresh data)
			numbers.forEach((numberInfo) => {
				if (numberInfo.number) {
					const cachedSettings = this.state.numberSettingsCache.get(numberInfo.number);
					if (cachedSettings) {
						numberInfo.audio_transcription = cachedSettings.audioTranscription ? 1 : 0;
					} else {
						// Fallback if somehow not in cache
						numberInfo.audio_transcription = 0;
					}
				}
			});

			this.setState((prevState) => {
				const updateNumberList = (numberList) =>
					(numberList || []).map((num) => {
						const matching = numbers.find((n) => n.id === num.id || n.number === num.number);
						return matching ? { ...num, audio_transcription: matching.audio_transcription } : num;
					});

				const updateNumbersObject = (numbersObj) => ({
					actives: updateNumberList(numbersObj?.actives),
					inactives: updateNumberList(numbersObj?.inactives),
				});

				const updatedBasicNumbers = updateNumbersObject(prevState.basicNumbers);
				const updatedProNumbers = updateNumbersObject(prevState.proNumbers);

				return {
					basicNumbers: updatedBasicNumbers,
					proNumbers: updatedProNumbers,
					numbers: {
						actives: [].concat(updatedBasicNumbers.actives, updatedProNumbers.actives),
						inactives: [].concat(updatedBasicNumbers.inactives, updatedProNumbers.inactives),
					},
				};
			});
		} catch (error) {
			console.warn('Failed to load transcription settings for numbers:', error);
		}
	}

	clearNumberSettingsCache() {
		this.state.numberSettingsCache.clear();
	}

	async getListOfApi() {
		this.setState({ loadingApis: true });
		const request = {
			action: 'getApis',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			lang: this.state.lang,
		};

		await api.post('getApis', request).then((res) => {
			this.setState({ loadingApis: false });
			if (res.data.status) {
				this.setState({ apis: res.data.dados });
			}
		});
	}

	async messagesOnQueue(token) {
		const request = {
			action: 'messagesOnQueue',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			token,
		};

		const result = await api.post('messagesOnQueue', request);
		return result.data;
	}

	async clearQueue(token) {
		const request = {
			action: 'clearQueue',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			token,
		};

		const result = await api.post('clearQueue', request);

		return result.data.status;
	}

	async deleteNumber(id, number) {
		const request = {
			action: 'deleteNumber',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			id,
			number,
		};

		const result = await api.post('deleteNumber', request);

		if (result.data.status) {
			await this.deleteNumberSettings(number);
			return result.data.status;
		} else {
			throw result.data;
		}
	}

	async sendMessage(msg, maxRetries = 3) {
		let retryCount = 0;

		while (retryCount < maxRetries) {
			try {
				const response = await this.sendMessageRetry(msg, retryCount);
				return response;
			} catch (error) {
				if (error.response && error.response.status === 502) {
					retryCount++;
					console.log(`Erro 502: Tentativa ${retryCount} de ${maxRetries}`);

					if (retryCount >= maxRetries) {
						console.log(['Falha após todas as tentativas:', error]);
						throw error;
					}
				} else {
					console.log(['SendMessage:', error]);
					throw error;
				}
			}
		}
	}

	async sendMessageRetry(msg, retryCount) {
		const { language } = this.props.language;
		this.setState({ loadingSendMessage: true });

		if (msg.message) {
			return new Promise(async (resolve, reject) => {
				const { placement } = this.state;

				const placementMap = {
					DEFAULT: 'Default',
					CRM_LEAD_DETAIL_TAB: 'Aba do Lead',
					CRM_LEAD_DETAIL_ACTIVITY: 'Aba do Lead',
					lead: 'Aba do Lead',
					CRM_DEAL_DETAIL_TAB: 'Aba do Negócio',
					deal: 'Aba do Negócio',
					CRM_CONTACT_DETAIL_TAB: 'Aba do Contato',
					contact: 'Aba do Contato',
					CRM_COMPANY_DETAIL_TAB: 'Aba da Empresa',
				};

				const data = new FormData();

				const entityNumbers = this.props.bitrix24.listOfNumbers.map((element) => element.VALUE);
				data.append('action', 'sendMsg');
				data.append('domain', this.state.infos.domain);
				data.append('auth', this.state.infos.auth);
				data.append('msg', msg.message);
				data.append('from', msg.from);
				data.append(
					'to',
					JSON.stringify(
						!msg.registerOnChat
							? msg.to
							: msg.to.map((el) => {
									const res = this.props.bitrix24.listOfNumbers.filter((item) => item.VALUE === el);
									if (res.length > 0) {
										res[0].IS_FROM_CRM = true;
										return res[0];
									} else {
										return { VALUE: el, IS_FROM_CRM: false };
									}
							  }),
					),
				);
				data.append('files', msg.files[0]);
				data.append('user_id', this.state.user.ID);
				data.append('entityNumbers', entityNumbers);
				data.append('user', JSON.stringify(this.props.bitrix24.auth));
				data.append('registerOnChat', msg.registerOnChat);
				data.append('language', this.props.language.lang);

				if (msg.mobile) {
					data.append('PLACEMENT', JSON.stringify({ options: { ID: msg.user_id } }));
					data.append('id_entity', placementMap[msg.id_entity]);
				} else if (placement.placement.includes('CRM_DYNAMIC')) {
					data.append('PLACEMENT', JSON.stringify(placement));
					data.append('id_entity', 'SPA');
				} else {
					data.append('PLACEMENT', JSON.stringify(placement));
					data.append('id_entity', placementMap[placement.placement]);
				}

				const config = {
					headers: {
						'content-type': 'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
					},
				};
				await api
					.post('sendMsg', data, config)
					.then((res) => {
						this.setState({ loadingSendMessage: false });
						if (res.data.status) {
							resolve(res.data);
						} else {
							reject(res.data);
						}
					})
					.catch((error) => {
						// Rejeita o erro para ser tratado no sendMessage e não loga o erro aqui
						this.setState({ loadingSendMessage: false });
						reject(error);
					});
			});
		} else if (msg.params) {
			return new Promise(async (resolve, reject) => {
				const { placement } = this.state;

				const placementMap = {
					DEFAULT: 'Default',
					CRM_LEAD_DETAIL_TAB: 'Aba do Lead',
					CRM_LEAD_DETAIL_ACTIVITY: 'Aba do Lead',
					lead: 'Aba do Lead',
					CRM_DEAL_DETAIL_TAB: 'Aba do Negócio',
					deal: 'Aba do Negócio',
					CRM_CONTACT_DETAIL_TAB: 'Aba do Contato',
					contact: 'Aba do Contato',
					CRM_COMPANY_DETAIL_TAB: 'Aba da Empresa',
				};

				const data = new FormData();

				data.append('action', 'startConversation');
				data.append('domain', this.state.infos.domain);
				data.append('auth', this.state.infos.auth);
				data.append('msg', JSON.stringify(msg.params));
				data.append('from', msg.from);
				data.append('api', msg.api);
				data.append('templateName', msg.templateName);
				data.append('templateLanguage', msg.templateLanguage);
				data.append('templateComponents', JSON.stringify(msg.templateComponents));
				data.append('wabaId', msg.wabaId);
				data.append('files', msg.files[0]);
				data.append('user_id', this.state.user.ID);
				data.append('access_token', this.props.bitrix24.auth.access_token);
				data.append('refresh_token', this.props.bitrix24.auth.refresh_token);
				data.append('user', JSON.stringify(this.props.bitrix24.auth));
				data.append('registerOnChat', msg.registerOnChat);
				data.append('language', this.props.language);
				data.append('to', JSON.stringify(msg.to));

				if (msg.mobile) {
					data.append('PLACEMENT', JSON.stringify({ options: { ID: msg.user_id } }));
					data.append('id_entity', placementMap[msg.id_entity]);
				} else if (placement.placement.includes('CRM_DYNAMIC')) {
					data.append('PLACEMENT', JSON.stringify(placement));
					data.append('id_entity', 'SPA');
				} else {
					data.append('PLACEMENT', JSON.stringify(placement));
					data.append('id_entity', placementMap[placement.placement]);
				}

				let http, url;
				if (msg.api === 'dialog') {
					http = dialogApi;
					url = 'messages/template/send-to-dialog';
				} else {
					http = api;
					url = 'startConversation';
				}

				const config = {
					headers:
						msg.api === 'dialog'
							? {
									'content-type':
										'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
									Domain: this.state.infos.domain,
									Number: msg.from,
							  }
							: {
									'content-type':
										'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
							  },
				};

				await http
					.post(url, data, config)
					.then((res) => {
						this.setState({ loadingSendMessage: false });
						if (res.data.status) {
							if (res.data.status === 400) reject(res.data.response);
							// Resposta inteira, como no sendMsg: quem chama precisa do dialog_id.
							resolve(res.data);
						} else {
							reject(res.data);
						}
					})
					.catch((error) => {
						this.setState({ loadingSendMessage: false });
						reject(error);
					});
			});
		}
	}

	async getListCampaigns() {
		this.setState({ loadingNumber: true });
		const request = {
			action: 'getCampaigns',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
		};

		await api.post('getCampaigns', request).then(async (res) => {
			this.setState({ loadingNumber: false });
			if (res.data.status) {
				this.setState({ campaigns: res.data.dados });
			}
		});
	}

	async clearCampaignQueue(id, number) {
		const request = {
			action: 'clearCampaignQueue',
			domain: this.state.infos.domain,
			auth: this.state.infos.auth,
			id,
			number,
		};

		const result = await api.post('clearCampaignQueue', request);

		if (result.data.status) {
			return result.data.status;
		} else {
			throw result.data;
		}
	}

	/**
	 * Asynchronously fetches the real-time status of numbers from the backend
	 * This method is called after getPermittedNumbers to update status information
	 * without blocking the initial number list display
	 *
	 * @param {Array} numbers - Array of number objects to get status for
	 */
	async getNumbersStatus(numbers, forceRefresh = false) {
		if (!numbers || numbers.length === 0) return;

		try {
			this.setState({ loadingNumbersStatus: true });

			const numberIds = numbers.filter((number) => number.id).map((number) => number.id);
			if (numberIds.length === 0) {
				this.setState({ loadingNumbersStatus: false });
				return;
			}

			const request = {
				domain: this.state.infos.domain,
				auth: this.state.infos.auth,
				number_ids: numberIds,
				...(forceRefresh && { force_refresh: true }),
			};

			await api
				.post('getNumbersStatus', request)
				.then((res) => {
					this.setState({ loadingNumbersStatus: false });
					if (res.data.status && res.data.data) {
						this.updateNumbersWithStatus(res.data.data);
					} else {
						console.warn('getNumbersStatus failed:', res.data);
					}
				})
				.catch((error) => {
					this.setState({ loadingNumbersStatus: false });
					console.warn('Failed to get numbers status:', error);
				});
		} catch (error) {
			this.setState({ loadingNumbersStatus: false });
			console.warn('Error in getNumbersStatus:', error);
		}
	}

	/**
	 * Updates the numbers state with the received status information
	 *
	 * @param {Object} statusData - Object with number IDs as keys and status info as values
	 */
	updateNumbersWithStatus(statusData) {
		if (!statusData || typeof statusData !== 'object') {
			console.warn('Invalid status data received:', statusData);
			return;
		}

		try {
			const updatedBasicNumbers = {
				actives: this.updateNumberListWithStatus(this.state.basicNumbers.actives, statusData),
				inactives: this.updateNumberListWithStatus(this.state.basicNumbers.inactives, statusData),
			};

			const updatedProNumbers = {
				actives: this.updateNumberListWithStatus(this.state.proNumbers.actives, statusData),
				inactives: this.updateNumberListWithStatus(this.state.proNumbers.inactives, statusData),
			};

			const updatedNumbers = {
				actives: [].concat(updatedBasicNumbers.actives, updatedProNumbers.actives),
				inactives: [].concat(updatedBasicNumbers.inactives, updatedProNumbers.inactives),
			};

			this.setState({
				basicNumbers: updatedBasicNumbers,
				proNumbers: updatedProNumbers,
				numbers: updatedNumbers,
			});
		} catch (error) {
			console.error('Error updating numbers with status:', error);
		}
	}

	/**
	 * Helper method to update a list of numbers with status information
	 *
	 * @param {Array} numberList - List of numbers to update
	 * @param {Object} statusData - Status information from backend (keyed by number ID)
	 * @returns {Array} Updated number list with status information
	 */
	updateNumberListWithStatus(numberList, statusData) {
		if (!Array.isArray(numberList) || !statusData || typeof statusData !== 'object') {
			return numberList;
		}

		return numberList.map((number) => {
			const numberStatus = statusData[number.id];

			if (numberStatus) {
				const sessionInfo = numberStatus.sessionInfo || {};
				const containerInfo = numberStatus.containerInfo || {};
				const isConnected = containerInfo.info?.connected || false;

				return {
					...number,
					sessionInfo: {
						...number.sessionInfo,
						...sessionInfo,
						status: isConnected,
						imgUrl:
							sessionInfo.imgUrl || sessionInfo.info?.profilePicUrl || number.sessionInfo?.imgUrl,
						phone: sessionInfo.phone || sessionInfo.info?.clientNumber || number.sessionInfo?.phone,
						name: sessionInfo.name || sessionInfo.info?.name || number.sessionInfo?.name,
						info: {
							...number.sessionInfo?.info,
							...sessionInfo.info,
							profilePicUrl:
								sessionInfo.imgUrl ||
								sessionInfo.info?.profilePicUrl ||
								number.sessionInfo?.info?.profilePicUrl,
							clientNumber:
								sessionInfo.phone ||
								sessionInfo.info?.clientNumber ||
								number.sessionInfo?.info?.clientNumber,
							name: sessionInfo.name || sessionInfo.info?.name || number.sessionInfo?.info?.name,
						},
					},
					containerInfo: {
						...number.containerInfo,
						...containerInfo,
						status: isConnected,
						info: {
							...number.containerInfo?.info,
							...containerInfo.info,
						},
					},
				};
			}

			return number;
		});
	}

	async deleteNumberSettings(numberPhone) {
		if (!numberPhone?.trim()) return;

		try {
			const response = await apiV2.delete('/number-settings', {
				params: {
					domain: this.state.infos.domain,
					number: numberPhone,
				},
				headers: {
					'access-token': this.state.b24_access_token,
				},
			});

			// Clear cache for this number since settings have been deleted
			this.state.numberSettingsCache.delete(numberPhone);

			return response.data;
		} catch (error) {
			console.warn(
				`Failed to delete number settings for ${numberPhone}:`,
				error.response?.data?.message || error.message,
			);
		}
	}

	render() {
		return (
			<NumberContext.Provider value={this.state}>{this.props.children}</NumberContext.Provider>
		);
	}
}

export default SystemConsumer(Bitrix24Consumer(LanguageConsumer(NumberProvider)));
